"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOOP_LOGGER = exports.LogFormat = void 0;
var LogFormat;
(function (LogFormat) {
  LogFormat["STRING"] = "string";
  LogFormat["JSON"] = "json";
})(LogFormat || (exports.LogFormat = LogFormat = {}));
exports.NOOP_LOGGER = {
  logFormat: LogFormat.STRING,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logEvent: function (systemEvent) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
  }
};